// apps/web/src/offline/OfflineMemoryMatchService.js

const STORAGE_KEY =
    'offline_memory_matches'

// ======================================================
// GERAR ID LOCAL
// ======================================================

const createLocalId =
    () => {
        return `offline-memory-${Date.now()}-${Math.random()
            .toString(36)
            .slice(2, 10)}`
    }

// ======================================================
// LER FILA
// ======================================================

const getPendingMatches =
    async () => {
        try {
            const raw =
                localStorage.getItem(
                    STORAGE_KEY,
                )

            if (!raw) {
                return []
            }

            const parsed =
                JSON.parse(
                    raw,
                )

            return Array.isArray(
                parsed,
            )
                ? parsed
                : []
        } catch (error) {
            console.error(
                '[OFFLINE MEMORY] Erro ao ler partidas:',
                error,
            )

            return []
        }
    }

// ======================================================
// GRAVAR FILA
// ======================================================

const savePendingMatches =
    async (
        matches,
    ) => {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(
                Array.isArray(
                    matches,
                )
                    ? matches
                    : [],
            ),
        )
    }

// ======================================================
// SALVAR PARTIDA OFFLINE
// ======================================================

const saveMatch =
    async ({
        gameId,
        participant,
        completed,
        durationMs,
        attempts,
        errors,
        score,
        startedAt,
        finishedAt,
    }) => {
        if (!gameId) {
            throw new Error(
                'gameId não informado.',
            )
        }

        const id =
            createLocalId()

        const record = {
            id,

            localId:
                id,

            gameId,

            participant:
                participant ||
                null,

            completed:
                Boolean(
                    completed,
                ),

            durationMs:
                Number(
                    durationMs ||
                    0,
                ),

            attempts:
                Number(
                    attempts ||
                    0,
                ),

            errors:
                Number(
                    errors ||
                    0,
                ),

            score:
                Number(
                    score ||
                    0,
                ),

            startedAt:
                startedAt ||
                new Date()
                    .toISOString(),

            finishedAt:
                finishedAt ||
                new Date()
                    .toISOString(),

            syncStatus:
                'PENDING',

            createdAt:
                new Date()
                    .toISOString(),
        }

        const current =
            await getPendingMatches()

        await savePendingMatches([
            ...current,
            record,
        ])

        return record
    }

// ======================================================
// BUSCAR PARTIDA LOCAL
// ======================================================

const getMatchById =
    async (
        id,
    ) => {
        if (!id) {
            return null
        }

        const matches =
            await getPendingMatches()

        return (
            matches.find(
                (
                    item,
                ) =>
                    item.id ===
                    id ||
                    item.localId ===
                    id,
            ) ||
            null
        )
    }

// ======================================================
// REMOVER APÓS SINCRONIZAR
// ======================================================

const removeMatch =
    async (
        id,
    ) => {
        if (!id) {
            return
        }

        const matches =
            await getPendingMatches()

        const next =
            matches.filter(
                (
                    item,
                ) =>
                    item.id !==
                    id &&
                    item.localId !==
                    id,
            )

        await savePendingMatches(
            next,
        )
    }

// ======================================================
// EXPORT
// ======================================================

const OfflineMemoryMatchService = {
    saveMatch,
    getMatchById,
    getPendingMatches,
    removeMatch,
}

export default OfflineMemoryMatchService